import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=0ec46ae6&scoped=true"
import script from "./FileUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUpload.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=0ec46ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec46ae6",
  null
  
)

export default component.exports